/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NotePencilRegular from './note-pencil-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NotePencilRegular {...validProps} />;
}
SvgComponent.iconName = 'notePencilRegular';

export const NotePencilRegularIcon = svgIconWrapper(SvgComponent);
